import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const OcurrencesByCallLocation = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <SimpleBars
            title={'Ocorrências com regulação por local de chamado (5+)'}
            horizontal={false}
            subtitles={chartData?.ocurrencesByCallLocation?.map((item) => item.description)}
            values={chartData?.ocurrencesByCallLocation?.map((item) => item.total || 0)}
            stacked
        />
    );
};